<template>
      <div no-body class="lku-exp"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <!-- <b-row v-else>
        <b-col lg="9">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=1 label="Filter">
              <b-row>
                <b-col class="pr-1" cols="3"><b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" size="sm" placeholder="Exp.Reimburs. No"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="4"><b-form-input v-model="tblData.dibayarke" @keyup.13.native="refresh()" size="sm" placeholder="Reimburs By"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="5"><b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" placeholder="Description" ></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=3 >
              <b-row>
                <b-button class="btn btn-success mr-1" @click="refresh()" size="sm"> <i class="fa fa-search"></i> Search</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear</b-button>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row> -->
            <b-table
              class="mb-0"
              ref="tblExp"
              responsive striped hover
              style="font-size:smaller;" 
              :items="data"
              :fields="fields" 
              show-empty
               @row-clicked="selectItem" 
            >
              <template v-slot:cell(lineno)="data">
                {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
              </template>

              <template v-slot:cell(umasuk)="data">
                  {{(data.item.umasuk)|numFormat}}
              </template>
              <template v-slot:cell(ukeluar)="data">
                  {{(data.item.ukeluar)|numFormat}}
              </template>
              <template v-slot:cell(saldo)="data">
                  {{(data.item.saldo)|numFormat}}
              </template>
        </b-table>
  </div>
</template>
<style lang="scss">
  .lku-exp {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import expense from "../../apis/expensesnote";

export default {
  data() {
    return {
      fields: [
              {
                key: "lineno",
                label: "No.",
                thStyle: "width:40px"
              },              {
                key: "namadana",
                label: "Nama Dana",
                sortable: true,
              },
              {
                key: "nomor",
                label: "Nomor Referensi",
                sortable: true
              },
              {
                key: "umasuk",
                label: "Total Dana",
                thStyle: "width:140px",
                thClass: "text-right",
                tdClass: "text-right"
              },
              {
                key: "ukeluar",
                label: "Pemakaian",
                thStyle: "width:140px",
                thClass: "text-right",
                tdClass: "text-right"
              },
              {
                key: "saldo",
                label: "Saldo",
                thStyle: "width:140px",
                thClass: "text-right",
                tdClass: "text-right"
              },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'namadana',
        sortDesc: true, udahKlaim:'0'
      },
      lkuLoading:false
    };
  },
  methods: {
    data: async function() {
      const list = await expense.list();          
      return list;
    },

    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    // clearFilter() {
    //     this.tblData.uraian=  '';
    //     this.tblData.nomor=  '';
    //     this.tblData.dibayarke=  '';
    //     this.refresh();
    // },    
    refresh: async function() {
      this.$refs.tblExp.refresh();
    }
  }
};
</script>
